import { useMutationState } from '@tanstack/react-query';

export const usePendingAuth = () => {
  const isSomeSignInMutationPending = useMutationState({
    filters: { mutationKey: ['auth', 'signin'] },
  }).some((mutation) => mutation.status === 'pending');

  const isSomeSignUpMutationPending = useMutationState({
    filters: { mutationKey: ['auth', 'signup'] },
  }).some((mutation) => mutation.status === 'pending');

  return isSomeSignInMutationPending || isSomeSignUpMutationPending;
};
